// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found {
  text-align: center;
  margin-top: 150px;
}

.not-found h1 {
  font-size: 4.5rem;
  color: #766c6c;
  padding-bottom: 1rem;
}

.not-found p {
  font-size: 1.2rem;
}

.not-found a {
  color: #007bff;
  text-decoration: none;
}

.mat-icon {
  width: unset;
  font-size: 200px;
}

.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 100, "GRAD" -25, "opsz" 48;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/page-not-found/page-not-found.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;AADF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;AAFF;;AAOA;EACE,oEACA;AALF","sourcesContent":["\r\n\r\n.not-found {\r\n  text-align: center;\r\n  margin-top: 150px;\r\n  ;\r\n}\r\n\r\n.not-found h1 {\r\n  font-size: 4.5rem;\r\n  color: #766c6c;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.not-found p {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.not-found a {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n}\r\n\r\n.mat-icon{\r\n  width:unset;\r\n  font-size: 200px;\r\n}\r\n\r\n\r\n\r\n.material-symbols-outlined {\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 100,\r\n  'GRAD' -25,\r\n  'opsz' 48\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
